import { Component, OnInit } from '@angular/core';
import { WeatherService } from 'src/app/Services/weather.service';
import { ShipCoordinatesService } from 'src/app/Services/ship-coordinates.service';
import { UserData } from 'src/app/Models/employee-and-user-data';
@Component({
  selector: 'app-weather',
  templateUrl: './weather.component.html',
  styleUrls: ['./weather.component.css'],
})
export class WeatherComponent implements OnInit {
  WeatherData?: any;
  userdata?: UserData;
  ShipCoordData?: any;
  WeatherIconData?: any;
  shpid: number | undefined;

  constructor(
    private WeatherService: WeatherService,
    private ShipCoordinatesService: ShipCoordinatesService
  ) {}

  ngOnInit() {
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.shpid = this.userdata?.shipid!;
    this.getShipCoordinates();
  }
  getShipCoordinates() {
    this.ShipCoordData = this.ShipCoordinatesService.getShipCoordinates(
      this.shpid
    ).subscribe((ShipCoordData) => this.setShipCoordinates(ShipCoordData));
  }

  setShipCoordinates(data: any) {
    this.ShipCoordData = data;
    if (this.ShipCoordData.GetShipCoordinates.Result.Status == 'A') {
      this.ShipCoordData =
        this.ShipCoordData.GetShipCoordinates.ShipCoordinates;
      this.getWeatherData(
        this.ShipCoordData.latitude,
        this.ShipCoordData.longitude
      );
    }
  }
  getWeatherData(lat: number, long: number) {
    this.WeatherService.getWeatherDataAndIcon(lat, long).subscribe(
      ({ weather, icon }) => {
        this.setWeatherData(weather);
        this.setWeatherIconData(icon);
      }
    );
  }

  setWeatherData(data: any) {
    this.WeatherData = data;
  }
  setWeatherIconData(data: any) {
    this.WeatherIconData = data;
    if (this.WeatherIconData.GetWeatherIcons.Result.Status == 'A') {
      this.WeatherIconData = this.WeatherIconData.GetWeatherIcons.WeatherIcon;
    }
  }
}
